import axios from 'axios';
import store from '../store';
import token from './token';
import requestManager from './requestManager';

export default {
  initAxiosInterceptors() {
    // BEFORE request
    axios.interceptors.request.use(
      async (request) => {
        // --- 1. ENSURE TRAILING SLASH ---
        if (request.url) {
          const hasQueryParams = request.url.includes('?');

          if (hasQueryParams) {
            // Inserts a slash right before query parameters if missing
            // Example: /awards/1?sort=desc -> /awards/1/?sort=desc
            request.url = request.url.replace(/\/?(\?.*)$/, '/$1');
          } else if (!request.url.endsWith('/')) {
            // Appends a slash to the end if missing
            // Example: /awards/1 -> /awards/1/
            request.url += '/';
          }
        }

        // Disable duplicate request cancellation as it's too aggressive
        // and causes issues with multiple components loading simultaneously
        //
        // // Generate unique key for this request
        // const requestKey = requestManager.generateRequestKey(request);
        //
        // // Create cancel token for this request (for axios 0.18.0)
        // const cancelToken = requestManager.createCancelToken(requestKey);
        // request.cancelToken = cancelToken;
        //
        // // Cleanup old requests periodically
        // if (Math.random() < 0.01) { // 1% chance to clean up
        //   requestManager.cleanupOldRequests();
        // }

        // show loader BEFORE API request send
        // check if request uses auth, if yes check the token expire
        if (request.headers.Authorization) {
          // getting access token
          const access = store.getters['auth/access'];
          if (!access) {
            // logout user if access token is undefinded
            await store.dispatch('auth/userLogout');
          } else if (token.checkAccessExpire()) {
            // refresh tokens pair if current token is expired
            await store.dispatch('auth/userRefresh');
            // update auth token on current request
            request.headers.Authorization = `Bearer ${store.getters['auth/access']}`;
          }
        }
        return request;
      },
      (e) => {
        // hide loader on error
        return Promise.reject(e);
      },
    );
    // first place that every request response appear
    axios.interceptors.response.use(
      (response) => {
        // Duplicate request cancellation disabled
        // const requestKey = requestManager.generateRequestKey(response.config);
        // requestManager.removeRequest(requestKey);

        // response success based on HTTP status >400
        // hide loader on success response
        // flush alerts (if there is any alert it will hide it)
        store.dispatch('flushAlert');
        return response;
      },
      (e) => {
        // Duplicate request cancellation disabled
        // if (e.config) {
        //   const requestKey = requestManager.generateRequestKey(e.config);
        //   requestManager.removeRequest(requestKey);
        // }

        // Ignore cancelled requests
        if (axios.isCancel(e)) {
          console.log('Request cancelled:', e.message);
          return Promise.reject(e);
        }

        if (e.response) {
          // get error response means that HTTP status >=400
        // hide loader in any response
          // user should login when token expired
          if (
            e.response.data.name === 'JsonWebTokenError'
          || e.response.data.name === 'TokenExpiredError'
          ) {
            store.dispatch('auth/userLogout');
            return Promise.reject(e);
          }
          // show alert message on 500 server error
          switch (e.response.status) {
            case 500:
              store.dispatch('initAlert', {
                type: 'error',
                message: e.response.data.message,
              });
              break;
            default:
              break;
          }
        }
        return Promise.reject(e);
      },
    );
  },
};
